export const getLoginUrl = () => new URL('/auth', window.origin).href;
